export function LinkIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.47154 12.2425L7.52874 13.1853C6.22699 14.4871 4.11644 14.4871 2.81469 13.1853C1.51294 11.8836 1.51294 9.77305 2.81469 8.4713L3.7575 7.52849M12.2428 8.4713L13.1856 7.52849C14.4873 6.22674 14.4873 4.11619 13.1856 2.81445C11.8838 1.5127 9.77329 1.5127 8.47154 2.81445L7.52874 3.75725M5.66681 10.3332L10.3335 5.66655" stroke="black" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  );
}

LinkIcon.displayName = 'LinkIcon';